"use client";

import { useQuery } from "@tanstack/react-query";
import { getBlogApi } from "@/util/api/blog";
import { IBlog } from "@/util/types/blog";
import { useParams } from "next/navigation";
import Preview from "@/components/dashboard/blogs/preview";
import AppLayout from "@/components/app/applayout";
import { Box } from "@mui/material";
import { appResponse } from "@/util";

export default function BlogPage() {
  const params = useParams();
  const fullSlug = Array.isArray(params?.slug) ? params.slug[0] : params?.slug;

  const blogId = fullSlug?.split("-").pop();

  const { data, isPending } = useQuery<appResponse<IBlog>>({
    queryKey: ["blog", blogId],

    queryFn: () => {
      if (!blogId) return Promise.reject("No blogId found");
      return getBlogApi(blogId);
    },
    enabled: !!blogId,
  });

  return (
    <AppLayout>
      <Box>
        <Preview isLoading={isPending} data={data?.payload} />
      </Box>
    </AppLayout>
  );
}
